<div class="delegationPanelList">
<app-panel-list [panelList]="myDelegationsData"
[showLoader] = "showLoader" 
[noResultFound] = "noData"
(selectedItems)="getSelectedItems($event)" [ifAdditionalItems]="true">
  <span class="additional-items">
    <p-checkbox   
    class="col p-0 pr-2"
    name="showInactiveDelegates"
    value="all"
    [(ngModel)]="isActiveSelected"
    [binary]="true"
    (onChange)="checkboxSelection($event)"
    ></p-checkbox>
  <app-label labelText="Show Inactive"></app-label>
  </span>
    <ng-template #templateRef let-data="dataVar">
      <div panel-content class="grid delegationPanelCards">
        <div class="col-5 delegationOverflow">
          <app-label labelText="Scope"></app-label>
          <div *ngIf="data?.scope == 2">
            <div *ngFor="let item of data?.documentDisplayInformations">
                <a class="underline text-primary" style="cursor: pointer;" (click)="openDocument(item?.number,item?.version)">
                <app-read-only readonlyText="{{ item?.number }} {{item?.title}} (v{{ item?.version }})" toolTipMessage="{{ item?.number }} {{item?.title}} (v{{ item?.version }})"></app-read-only>
                </a>
            </div>
          </div>
          <div *ngIf="data?.scope==1">
            <app-read-only readonlyText="General - Document Control"></app-read-only>
          </div>
        </div>
        <div class="col-2 w-9rem delegationOverflow text-left">
          <app-label labelText="Assignment"></app-label>
          <div *ngFor="let assignment of data?.assignmentNames">
          <app-read-only readonlyText="{{ assignment }}"></app-read-only>
          </div>
        </div>
        <div class="col-3 w-13rem text-left delegationOverflow" *ngIf="isDelegateToDisplayed">
          <app-label labelText="Delegate To"></app-label>
          <div *ngFor="let delegateTo of data?.delegateToInformation">
            <app-read-only  [ngClass]="{'inActiveGroup':delegateTo.isTerminated===true}"
            readonlyText="{{ delegateTo.name }}" toolTipMessage="{{ delegateTo.name }}"></app-read-only>
          </div>
        </div>
        <div class="col-3 w-13rem text-left delegationOverflow" *ngIf="isDelegateFromDisplayed">
            <app-label labelText="Delegate From"></app-label>
            <app-read-only [ngClass]="{'inActiveGroup':data?.delegateFromIsTerminated===true}"
            readonlyText="{{ data?.delegateFrom }}" toolTipMessage="{{ data?.delegateFrom}}"></app-read-only>
          </div>
        <div class="col w-5rem text-left">
          <app-label labelText="Start Date"></app-label>
          <app-read-only readonlyText="{{ data?.startDate | date: 'dd-MMM-yyyy' }}"></app-read-only>
        </div>
        <div class="col w-5rem text-left">
          <app-label labelText="End Date"></app-label>
          <app-read-only readonlyText="{{ data?.endDate | date: 'dd-MMM-yyyy' }}"></app-read-only>
        </div>
        <div class="col-1 text-left">
          <app-label labelText="Is Active?"></app-label>
          <div class="grid">
              <div class="col max-w-0">
              <em
                class="pi pi-circle-fill"
                [ngClass]="{
                  active: data?.isActive == 'Yes',
                  inactive: data?.isActive == 'No'
                  }"
              ></em>
              </div>
              <div class="col ml-1">
                <app-read-only readonlyText="{{ data?.isActive }}"></app-read-only>
              </div>
            </div>
        </div>
      </div>
    </ng-template>
  </app-panel-list>
</div>